import NextShowItem from "./NextShowItem.jsx";
import { map } from 'lodash';
const LOCALE = 'de';
import { toTime } from '/utils';

export default function DayItem({day, shows = [], title, active, linkTitle=false}) {
    return (
        <>
          <div className="flex flex-row pb-2 mb-2 border-b border-black-rgba-bg">
            <div className="w-4 md:w-10 mr-4 sm:w-12 flex flex-col justify-center">
              <div
                className="text-sm sm:text-base">{day.setLocale(LOCALE).toFormat('ccc')}</div>
              <div
                className={`${active ? 'w-8 h-8 bg-gold text-white px-1' : 'font-bold'} text-sm xl:text-base rounded-full`}>
                {day.toFormat('dd')}
              </div>
            </div>
            <div className="flex-1">
              {shows.map(show => {
                  let subtitle = null;
                  if (show.timetable && show.timetable.length > 1) {
                      subtitle = map(show.timetable, t => `${toTime(t.start_date)} ${t.title}`).join(' / ');
                  }
                  return (
                      <NextShowItem key={show.slug}
                                    url={linkTitle && show.event?.slug && `/theater-details/${show.event?.slug}`}
                                    slug={show.slug}
                                    subtitle={subtitle}
                                    title={show.event?.title}
                                    time={show.start_date}/>
                  );
              })}
            </div>
          </div>
        </>
    );
}

